import * as React from "react";
import {
  joinShortcutAriaLabels,
  resolveShortcutKeys,
  type DesktopPlatform,
  type ShortcutKey,
} from "@/core/utils/desktop-platform";
import { Kbd, KbdGroup } from "./kbd";

export interface ShortcutKbdProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, "children"> {
  keys: readonly ShortcutKey[];
  platform?: DesktopPlatform;
}

const ShortcutKbd = React.forwardRef<HTMLSpanElement, ShortcutKbdProps>(
  ({ keys, platform, className, ...props }, ref) => {
    const resolved = resolveShortcutKeys(keys, platform);

    return (
      <KbdGroup
        ref={ref}
        role="group"
        aria-label={joinShortcutAriaLabels(resolved)}
        className={className}
        {...props}
      >
        {resolved.map(({ label }, index) => (
          <Kbd key={index} aria-hidden>
            {label}
          </Kbd>
        ))}
      </KbdGroup>
    );
  },
);
ShortcutKbd.displayName = "ShortcutKbd";

export { ShortcutKbd };
